<template>
  <div class="container">
    <!-- Grupo de Cores Horímetro -->
    <b-form-group label="Cores Horímetro:" label-for="horimeter-green">
      <p style="font-size: 12px;">Adicione os Índices de Cores Horímetro</p>
      <div class="d-flex align-items-center mb-3">
        <div class="color-box green"></div>
        <b-form-input
          id="horimeter-green"
          v-model="model.horimeterGreen"
          placeholder="Valor Índice Verde de Horímetro"
          type="number"
          class="flex-grow-1"
          aria-describedby="horimeter-green-help"
        ></b-form-input>
      </div>
      <div class="d-flex align-items-center mb-3">
        <div class="color-box yellow"></div>
        <b-form-input
          v-model="model.horimeterYellow"
          placeholder="Valor Índice Amarelo de Horímetro"
          type="number"
          class="flex-grow-1"
          aria-describedby="horimeter-yellow-help"
        ></b-form-input>
      </div>
      <div class="d-flex align-items-center mb-3">
        <div class="color-box red"></div>
        <b-form-input
          v-model="model.horimeterRed"
          placeholder="Valor Índice Vermelho de Horímetro"
          type="number"
          class="flex-grow-1"
          aria-describedby="horimeter-red-help"
        ></b-form-input>
      </div>
    </b-form-group>

    <!-- Grupo de Cores Dias -->
    <b-form-group label="Cores Dias:" label-for="days-green">
      <p style="font-size: 12px;">Adicione os Índices de Cores Dias</p>
      <div class="d-flex align-items-center mb-3">
        <div class="color-box green"></div>
        <b-form-input
          id="days-green"
          v-model="model.daysGreen"
          placeholder="Valor Índice Verde de Dias"
          type="number"
          class="flex-grow-1"
          aria-describedby="day-green-help"
        ></b-form-input>
      </div>
      <div class="d-flex align-items-center mb-3">
        <div class="color-box yellow"></div>
        <b-form-input
          v-model="model.daysYellow"
          placeholder="Valor Índice Amarelo de Dias"
          type="number"
          class="flex-grow-1"
          aria-describedby="day-yellow-help"
        ></b-form-input>
      </div>
      <div class="d-flex align-items-center mb-3">
        <div class="color-box red"></div>
        <b-form-input
          v-model="model.daysRed"
          placeholder="Valor Índice Vermelho de Dias"
          type="number"
          class="flex-grow-1"
          aria-describedby="day-red-help"
        ></b-form-input>
      </div>
    </b-form-group>

    <!-- Grupo de Cores KM -->
    <b-form-group label="Cores KM:" label-for="km-green">
      <p style="font-size: 12px;">Adicione os Índices de Cores KM</p>
      <div class="d-flex align-items-center mb-3">
        <div class="color-box green"></div>
        <b-form-input
          id="km-green"
          v-model="model.kmGreen"
          placeholder="Valor Índice Verde de KM"
          type="number"
          class="flex-grow-1"
          aria-describedby="km-green-help"
        ></b-form-input>
      </div>
      <div class="d-flex align-items-center mb-3">
        <div class="color-box yellow"></div>
        <b-form-input
          v-model="model.kmYellow"
          placeholder="Valor Índice Amarelo de KM"
          type="number"
          class="flex-grow-1"
          aria-describedby="km-yellow-help"
        ></b-form-input>
      </div>
      <div class="d-flex align-items-center mb-3">
        <div class="color-box red"></div>
        <b-form-input
          v-model="model.kmRed"
          placeholder="Valor Índice Vermelho de KM"
          type="number"
          class="flex-grow-1"
          aria-describedby="km-red-help"
        ></b-form-input>
      </div>
    </b-form-group>
  </div>
</template>

<script>
export default {
  props: {
    model: {
      type: Object,
      required: true
    }
  },
  methods: {
    onSubmit() {
      console.log("Form submitted:", this.model);
    }
  }
};
</script>

<style scoped>
.container {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
}

.color-box {
  width: 20px;
  height: 20px;
  margin-right: 10px;
  flex-shrink: 0;
  border: 1px solid #ccc;
  border-radius: 3px;
}

.color-box.green {
  background-color: green;
}

.color-box.yellow {
  background-color: yellow;
}

.color-box.red {
  background-color: red;
}

.flex-grow-1 {
  flex-grow: 1;
}
</style>
